export const primary = "#FF8800";
export const gray = "#707070";
export const dark= "#2E2E2E";


// WEBPACK FOOTER //
// ./src/styles/Colors.ts